export default "__VITE_ASSET__D5NjW2v4__"